import React, { useEffect } from 'react'
import DreamboothFilm from '/assets/images/dreambooth-film.png'

interface PrintData {
  printerName: string
  copies: number
  images: string[]
  orientation: 'landscape' | 'portrait'
  pageSize: { height: number; width: number }
}

const PrintPage: React.FC = () => {
  useEffect(() => {
    const handlePrintData = (data: PrintData): void => {
      console.log('Received print data:', data)

      const image = document.getElementById('print-image') as HTMLImageElement
      if (!image) return

      image.src = data.images[0]

      image.onload = (): void => {
        console.log('Image loaded successfully')
        window.api?.send('image-loaded')
      }

      image.onerror = (): void => {
        console.error('Error loading the image')
        window.api?.send('image-load-error')
      }
    }

    window.api?.on<PrintData>('receive-print-data', handlePrintData)

    return (): void => {
      window.api?.removeListener<PrintData>('receive-print-data', handlePrintData)
    }
  }, [])

  return (
    <div className="print-page">
      <img id="print-image" alt="Content to Print" src={DreamboothFilm} className="w-full h-auto" />
    </div>
  )
}

export default PrintPage
